import { render, staticRenderFns } from "./live-eks.vue?vue&type=template&id=98d3567c&"
import script from "./live-eks.vue?vue&type=script&lang=js&"
export * from "./live-eks.vue?vue&type=script&lang=js&"
import style0 from "./live-eks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "live-eks.vue"
export default component.exports